<template>
  <div class="p-subject">
    <CardTitle>{{ titleName }}</CardTitle>
    <!-- <div class="tab-change">
      <p class="tab pointer">教师</p>
      <p class="tab pointer">学生</p>
    </div> -->
    <div class="subject-count"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import CardTitle from './card-title.vue';

export default {
  name: 'SubjectCount',
  components: {
    CardTitle,
  },
  props: {
    titleName: {
      type: String,
      default: '科目分布',
    },
    user: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      subjectList: [],
      count: [40, 62, 68, 25, 23],
    };
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.subject-count'));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: '15% ',
        },
        xAxis: {
          data: ['语文', '数学', '英语', '物理', '化学'],
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          axisLabel: {
            formatter(value) {
              let val = '';
              if (value >= 1000) {
                val = `${value / 1000}k`;
              } else if (value < 1000) {
                val = value;
              }
              return val;
            },
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255, 0.4)',
            },
          },
        },
        series: [
          {
            name: '教师',
            type: 'bar',
            barwidth: 10,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00F1FF',
                }, {
                  offset: 0.72,
                  color: '#48A6FF',
                }, {
                  offset: 1,
                  color: '#8A4FFF',
                }]),
                label: {
                  formatter(params) {
                    return params.data;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '12',
                    color: '#fff',
                  },

                },
              },
            },
            data: this.user,
          },
        ],
      });
    },
  },
  mounted() {
    this.initCharts();
  },
};
</script>
<style lang="scss" scoped>
.p-subject {
  box-sizing: border-box;
  position: relative;
  padding: 20px;
  width: 402px;
  height: 296px;
  background: url("~@/views/pt/images/exhibition-resource_subject.png")
    no-repeat;
  background-size: 402px 296px;
  .tab-change {
    width: 130px;
    height: 32px;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0px 8px 8px 0px rgba(0, 61, 163, 0.22),
      0px -8px 8px 0px rgba(0, 61, 163, 0.27),
      8px 0px 8px 0px rgba(0, 61, 163, 0.22),
      -8px 0px 8px 0px rgba(0, 61, 163, 0.27);
    border-radius: 4px;
    border: 2px solid;
    border-image: linear-gradient(
        273deg,
        rgba(53, 162, 255, 0.19),
        rgba(118, 223, 255, 1),
        rgba(75, 143, 255, 0.31)
      )
      2 2;
    position: absolute;
    top: 20px;
    right: 60px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .tab {
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #e0efff;
      line-height: 20px;
    }
  }
  .subject-count {
    width: 100%;
    height: 280px;
  }
}
</style>
